/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Growth_Bullet_1Inputs */

const en_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free instruction and range access for 20+ high schools and 40+ teams each season`)
};

const es_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucción gratuita y acceso al campo de prácticas para más de 20 preparatorias y más de 40 equipos cada temporada`)
};

const de_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Unterricht und Zugang zur Driving Range für über 20 weiterführende Schulen und über 40 Teams pro Saison`)
};

const zh_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每个赛季为 20 多所高中和 40 多支球队提供免费指导和练习场使用`)
};

const ar_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليم مجاني ووصول إلى الرينج لأكثر من 20 مدرسة ثانوية وأكثر من 40 فريقاً كل موسم`)
};

const fr_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignement gratuit et accès au practice pour plus de 20 lycées et plus de 40 équipes chaque saison`)
};

const vi_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hướng dẫn miễn phí và quyền sử dụng sân tập cho hơn 20 trường trung học và hơn 40 đội mỗi mùa`)
};

const sw_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mafunzo ya bure na ufikiaji wa uwanja wa mazoezi kwa shule 20+ za upili na timu 40+ kila msimu`)
};

const th_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สอนฟรีและให้ใช้สนามไดรฟ์กอล์ฟสำหรับโรงเรียนมัธยมปลายกว่า 20 แห่งและทีมกว่า 40 ทีมในแต่ละฤดูกาล`)
};

const bs_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besplatna nastava i pristup vježbalištu za 20+ srednjih škola i 40+ timova svake sezone`)
};

const ja_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎シーズン20校以上の高校・40チーム以上に無料指導とレンジ利用を提供`)
};

const ko_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매 시즌 20개 이상의 고등학교와 40개 이상의 팀에 무료 레슨과 드라이빙 레인지 이용 제공`)
};

const pt_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aulas gratuitas e acesso ao driving range para mais de 20 escolas de ensino médio e mais de 40 equipes a cada temporada`)
};

const it_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lezioni gratuite e accesso al campo pratica per oltre 20 scuole superiori e oltre 40 squadre ogni stagione`)
};

const sv_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis instruktion och tillgång till drivingrangen för 20+ gymnasier och 40+ lag varje säsong`)
};

const nl_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis les en toegang tot de driving range voor 20+ middelbare scholen en 40+ teams per seizoen`)
};

const da_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis undervisning og adgang til driving rangen for 20+ gymnasier og 40+ hold hver sæson`)
};

const nb_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis instruksjon og tilgang til drivingrangen for 20+ videregående skoler og 40+ lag hver sesong`)
};

const fi_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen opetus ja harjoitusalueen (rangen) käyttö yli 20 lukiolle ja yli 40 joukkueelle joka kausi`)
};

const pl_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatne lekcje i dostęp do driving range dla ponad 20 szkół średnich i ponad 40 drużyn w każdym sezonie`)
};

const ru_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бесплатные занятия и доступ к тренировочному полю (драйвинг-рейнджу) для 20+ старших школ и 40+ команд каждый сезон`)
};

const tr_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Her sezon 20'den fazla lise ve 40'tan fazla takım için ücretsiz eğitim ve driving range erişimi`)
};

const hi_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20+ हाई स्कूल और 40+ टीमों के लिए प्रत्येक सीजन में मुफ्त निर्देश और रेंज का उपयोग`)
};

const id_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatihan gratis dan akses lapangan latihan untuk 20+ SMA dan 40+ tim setiap musim`)
};

const ms_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bimbingan dan akses lapang latihan percuma untuk 20+ sekolah menengah dan 40+ pasukan setiap musim`)
};

const cs_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezplatná výuka a přístup na driving range pro více než 20 středních škol a více než 40 týmů každou sezónu`)
};

const el_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δωρεάν εκπαίδευση και πρόσβαση στο driving range για 20+ λύκεια και 40+ ομάδες κάθε σεζόν`)
};

const he_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הדרכה חינם וגישה למגרש האימונים (דרייבינג ריינג') ליותר מ-20 בתי ספר תיכוניים ולמעלה מ-40 קבוצות בכל עונה`)
};

const af_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis onderrig en toegang tot die oefenbaan vir 20+ hoërskole en 40+ spanne elke seisoen`)
};

const hu_about_content_growth_bullet_1 = /** @type {(inputs: About_Content_Growth_Bullet_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingyenes oktatás és gyakorlópálya-használat több mint 20 középiskolának és több mint 40 csapatnak minden szezonban`)
};

/**
* | output |
* | --- |
* | "Free instruction and range access for 20+ high schools and 40+ teams each season" |
*
* @param {About_Content_Growth_Bullet_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_growth_bullet_1 = /** @type {((inputs?: About_Content_Growth_Bullet_1Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Growth_Bullet_1Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_growth_bullet_1(inputs)
	if (locale === "de") return de_about_content_growth_bullet_1(inputs)
	if (locale === "zh") return zh_about_content_growth_bullet_1(inputs)
	if (locale === "ar") return ar_about_content_growth_bullet_1(inputs)
	if (locale === "fr") return fr_about_content_growth_bullet_1(inputs)
	if (locale === "vi") return vi_about_content_growth_bullet_1(inputs)
	if (locale === "sw") return sw_about_content_growth_bullet_1(inputs)
	if (locale === "th") return th_about_content_growth_bullet_1(inputs)
	if (locale === "bs") return bs_about_content_growth_bullet_1(inputs)
	if (locale === "ja") return ja_about_content_growth_bullet_1(inputs)
	if (locale === "ko") return ko_about_content_growth_bullet_1(inputs)
	if (locale === "pt") return pt_about_content_growth_bullet_1(inputs)
	if (locale === "it") return it_about_content_growth_bullet_1(inputs)
	if (locale === "sv") return sv_about_content_growth_bullet_1(inputs)
	if (locale === "nl") return nl_about_content_growth_bullet_1(inputs)
	if (locale === "da") return da_about_content_growth_bullet_1(inputs)
	if (locale === "nb") return nb_about_content_growth_bullet_1(inputs)
	if (locale === "fi") return fi_about_content_growth_bullet_1(inputs)
	if (locale === "pl") return pl_about_content_growth_bullet_1(inputs)
	if (locale === "ru") return ru_about_content_growth_bullet_1(inputs)
	if (locale === "tr") return tr_about_content_growth_bullet_1(inputs)
	if (locale === "hi") return hi_about_content_growth_bullet_1(inputs)
	if (locale === "id") return id_about_content_growth_bullet_1(inputs)
	if (locale === "ms") return ms_about_content_growth_bullet_1(inputs)
	if (locale === "cs") return cs_about_content_growth_bullet_1(inputs)
	if (locale === "el") return el_about_content_growth_bullet_1(inputs)
	if (locale === "he") return he_about_content_growth_bullet_1(inputs)
	if (locale === "af") return af_about_content_growth_bullet_1(inputs)
	if (locale === "hu") return hu_about_content_growth_bullet_1(inputs)
	return en_about_content_growth_bullet_1(inputs)
});